module.exports = __webpack_public_path__ + "img/david-walker.1cf62c38.png";